import { getErrorMessage } from "../utils/commonUtils";
import {
  useDeleteQueryMutation,
  useExportQueryMutation,
  useInsertQueryMutation,
  useSelectQueryMutation,
  useUpdateQueryMutation,
} from "../redux/adhocQuery/adhocQueryApiSlice";

export default function useAdhocQuery() {
  const [selectQuery, { isLoading: selectQueryLoading }] =
    useSelectQueryMutation();
  const [exportQuery, { isLoading: exportQueryLoading }] =
    useExportQueryMutation();
  const [insertQuery, { isLoading: insertQueryLoading }] =
    useInsertQueryMutation();
  const [updateQuery, { isLoading: updateQueryLoading }] =
    useUpdateQueryMutation();
  const [deleteQuery, { isLoading: deleteQueryLoading }] =
    useDeleteQueryMutation();

  const selectQueryAPI = async (data: any) => {
    try {
      const response = await selectQuery(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const exportQueryAPI = async (data: any) => {
    try {
      const response = await exportQuery(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const insertQueryAPI = async (data: any) => {
    try {
      const response = await insertQuery(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const updateQueryAPI = async (data: any) => {
    try {
      const response = await updateQuery(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const deleteQueryAPI = async (data: any) => {
    try {
      const response = await deleteQuery(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  return {
    selectQueryAPI,
    selectQueryLoading,
    exportQueryAPI,
    exportQueryLoading,
    insertQueryAPI,
    insertQueryLoading,
    updateQueryAPI,
    updateQueryLoading,
    deleteQueryAPI,
    deleteQueryLoading,
  };
}
